import { mergeStyleSets } from '@uifabric/merge-styles';

const reviewListClassNames = (): { [key: string]: string } => mergeStyleSets({
  stack: {
    selectors: {
      '&> div:not(:first-child)': {
        borderTop: '1px solid #ddd'
      },
      p: {
        maxWidth: '80ch'
      }
    }
  },
  photos: <any>{
    display: 'grid',
    rowGap: 16,
    columnGap: 12,
    paddingTop: 16,
    gridTemplateColumns: '30fr 30fr 30fr',
    selectors: {
      '.loaded-image-container': {
        marginBottom: 16
      },
      canvas : {
        maxWidth: '100%'
      },
      '@media(max-width: 600px)': {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }
  }});

export default reviewListClassNames;
